module.exports = __webpack_public_path__ + "img/warning-24.32fe5a67.svg";